import { processGroupBy } from "./constants";
export const GET_METRIC_DATA = "/analytics_metric/GET_METRIC_DATA";
export const SET_METRIC_DATA = "analytics_metric/SET_METRIC_DATA";
export const GET_METRIC_DATA_FAILURE =
  "/analytics_metric/GET_METRIC_DATA_FAILURE";
export const SET_METRIC_CONTENT_GROUP_BY =
  "analytics_metric/SET_METRIC_CONTENT_GROUP_BY";
export const SET_METRIC_CONTENT_COMPARE_BY =
  "analytics_metric/SET_METRIC_CONTENT_COMPARE_BY";
export const SET_METRIC_CONTENT_VIEW =
  "analytics_metric/SET_METRIC_CONTENT_VIEW";
export const CLEAR_METRIC_DATA = "analytics_metric/CLEAR_METRIC_DATA";
export const GET_TOPLINE_METRICS_FAILURE =
  "analytics/GET_TOPLINE_METRICS_FAILURE";
export const ADD_TOPLINE_METRICS = "analytics_metric/ADD_TOPLINE_METRICS";
export const GET_TOPLINE_METRICS = "analytics_metric/GET_TOPLINE_METRICS";
export const GET_FLYERS = "analytics_metric/GET_FLYERS";
export const GET_FLYERS_FAILURE = "analytics_metric/GET_FLYERS_FAILURE";
export const SET_FLYERS = "analytics_metric/SET_FLYERS";
export const SET_SELECTED_FLYER_ID = "analytics_metric/SET_SELECTED_FLYER_ID";
export const GET_FLYER_ITEMS = "analytics_metric/GET_FLYER_ITEMS";
export const GET_FLYER_ITEMS_FAILURE =
  "analytics_metric/GET_FLYER_ITEMS_FAILURE";
export const SET_FLYER_ITEMS = "analytics_metric/SET_FLYER_ITEMS";
export const CLEAR_FLYER_ITEMS = "analytics_metric/CLEAR_FLYER_ITEMS";
export const SET_SELECTED_PUBLICATION_ID =
  "analytics_metric/SET_SELECTED_PUBLICATION_ID";

export const SET_METRIC_DATA_LOADING =
  "analytics_metrics/SET_METRIC_DATA_LOADING";
export const SET_FLYER_ITEMS_LOADING =
  "analytics_metrics/SET_FLYER_ITEMS_LOADING";
export const SET_FLYERS_LOADING = "analytics_metrics/SET_FLYERS_LOADING";
export const SET_TOPLINE_METRICS_LOADING =
  "analytics/SET_TOPLINE_METRICS_LOADING";

export const SET_SFML_ERROR_MESSAGE = "analytics/SET_SFML_ERROR_MESSAGE";
export const GET_SFML_DATA = "analytics/GET_SFML_DATA";
export const SAVE_SFML_DATA = "analytics/SAVE_SFML_DATA";

export enum MetricDataEndpointEnum {
  ITEM_METRIC = 1,
  FLYER_METRIC = 2,
  SPEND_METRIC = 3
}

export const setMetricDataLoading = (loading: boolean) => ({
  type: SET_METRIC_DATA_LOADING,
  payload: loading
});

export const setFlyerItemsLoading = (loading: boolean) => ({
  type: SET_FLYER_ITEMS_LOADING,
  payload: loading
});

export const getMetricData = (
  endpoint: MetricDataEndpointEnum,
  metric: string,
  merchant_id: number,
  us_based: boolean,
  flyer_run_ids: number[],
  group_by: string,
  compare_by: string,
  start_date: string,
  end_date: string,
  state_level: boolean = false
) => ({
  type: GET_METRIC_DATA,
  endpoint: endpoint,
  payload: {
    metric: metric,
    merchant_id: merchant_id,
    flyer_run_ids: flyer_run_ids,
    group_by: processGroupBy(group_by, us_based, state_level),
    compare_by: compare_by,
    start_date: start_date,
    end_date: end_date
  }
});

export const setMetricData = (metric_data: any) => ({
  type: SET_METRIC_DATA,
  payload: { metric_data }
});

export const clearMetricData = () => ({
  type: CLEAR_METRIC_DATA
});

export const getMetricDataFailure = () => ({
  type: GET_METRIC_DATA_FAILURE
});

export const setMetricContentGroupBy = (selection: string) => ({
  type: SET_METRIC_CONTENT_GROUP_BY,
  payload: selection
});

export const setMetricContentCompareBy = (selection: string) => ({
  type: SET_METRIC_CONTENT_COMPARE_BY,
  payload: selection
});

export const setMetricContentView = (selection: string) => ({
  type: SET_METRIC_CONTENT_VIEW,
  payload: selection
});

export const setToplineMetricsLoading = (loading: boolean) => ({
  type: SET_TOPLINE_METRICS_LOADING,
  payload: loading
});

export const getToplineMetrics = (
  metric: string,
  merchant_id: number,
  start_date: string,
  end_date: string
) => ({
  type: GET_TOPLINE_METRICS,
  payload: {
    metric: metric,
    merchant_id: merchant_id,
    start_date: start_date,
    end_date: end_date
  }
});

export const addToplineMetrics = (metrics: any) => ({
  type: ADD_TOPLINE_METRICS,
  payload: metrics
});

export const getToplineMetricsFailure = () => ({
  type: GET_TOPLINE_METRICS_FAILURE
});

export const setFlyersLoading = (loading: boolean) => ({
  type: SET_FLYERS_LOADING,
  payload: loading
});

export const getFlyers = (flyerRunIds: number[], setDefault: boolean) => ({
  type: GET_FLYERS,
  payload: { flyerRunIds, setDefault }
});

export const getFlyersFailure = () => ({
  type: GET_FLYERS_FAILURE
});

export const setFlyers = (flyers: any[]) => ({
  type: SET_FLYERS,
  payload: flyers
});

export const setSelectedFlyerId = (flyerId: number) => ({
  type: SET_SELECTED_FLYER_ID,
  payload: flyerId
});

export const getFlyerItems = (
  flyerId: number,
  metrics: string[],
  startDate: string,
  endDate: string,
  groupBy: string
) => ({
  type: GET_FLYER_ITEMS,
  payload: { flyerId, metrics, startDate, endDate, groupBy }
});

export const getFlyerItemsFailure = () => ({
  type: GET_FLYER_ITEMS_FAILURE
});

export const setFlyerItems = (flyerItems: any[]) => ({
  type: SET_FLYER_ITEMS,
  payload: flyerItems
});

export const clearFlyerItems = () => ({
  type: CLEAR_FLYER_ITEMS
});

export const setSelectedPublicationId = (publicationId: number) => ({
  type: SET_SELECTED_PUBLICATION_ID,
  payload: publicationId
});

export const setSFMLErrorMessage = (errorMessage: string) => ({
  type: SET_SFML_ERROR_MESSAGE,
  payload: errorMessage
});

export const getSfmlData = () => ({
  type: GET_SFML_DATA
});

export const saveSFMLData = (data: any) => ({
  type: SAVE_SFML_DATA,
  payload: data
});



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/actions.ts